module.exports = __webpack_public_path__ + "assets/img/mid-autumn-qr-code.0cb0d04b.png";